import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const CustomTooltip = ({ children, text }) => {
  const renderTooltip = (props) => <Tooltip {...props}>{text}</Tooltip>;
  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      {children}
    </OverlayTrigger>
  );
};
